module.exports = __webpack_public_path__ + "static/media/2DGACM5.21c62347.jpg";